import React, { useState } from "react";
import { Button, Modal, Row, Divider, Col, Table, Spin } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { main_wdr } from "../api/apiCent90";
import { ProfileOutlined } from "@ant-design/icons";

/**
 * ModalCheckAllCases
 * ปุ่ม "ตรวจเคสทั้งหมด" กดแล้วเปิด modal แสดง "สรุปจำนวนเคสตามรอบการส่ง"
 * ตาราง: รอบการส่ง | รถ | ที่ดิน | ทั้งหมด (นับจำนวนอย่างเดียว)
 */
function ModalCheckAllCases() {
  const [open, setOpen] = useState(false);
  const [dataMainS4, setDataMainS4] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(main_wdr, {
        statuses: [3, 4, 5, 6, 7],
        user: "admin888",
        flagHdpayment: true,
      });
      console.log("res.data", res.data);
      setDataMainS4(res.data.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setOpen(true);
    loadData();
  };
  const handleClose = () => setOpen(false);

  // จัดกลุ่มตามรอบการส่ง (roundDate ระดับวัน) แล้วนับแยก รถ/ที่ดิน และ ยังไม่รับเคส/รับเคสแล้ว
  // flagWcc === true -> รับเคสแล้ว, นอกนั้น -> ยังไม่รับเคส
  const buildSummary = () => {
    const map = {};
    dataMainS4.forEach((item) => {
      const d = item.roundDate ? dayjs(item.roundDate) : null;
      const key = d && d.isValid() ? d.format("YYYY-MM-DD") : "ไม่มีรอบ";
      if (!map[key]) {
        map[key] = {
          key,
          roundDate: key,
          roundLabel: d && d.isValid() ? d.format("DD/MM/YYYY") : "ไม่มีรอบ",
          carNew: 0, // รถ ยังไม่รับเคส
          carAccepted: 0, // รถ รับเคสแล้ว
          landNew: 0, // ที่ดิน ยังไม่รับเคส
          landAccepted: 0, // ที่ดิน รับเคสแล้ว
          total: 0,
        };
      }
      const accepted = item.flagWcc === true;
      const bucket = accepted ? "Accepted" : "New";
      if (Number(item.caseType) === 2) map[key]["car" + bucket] += 1;
      else if (Number(item.caseType) === 1) map[key]["land" + bucket] += 1;
      map[key].total += 1;
    });

    // เรียงตามรอบการส่งจากเก่า -> ใหม่ (กลุ่ม "ไม่มีรอบ" ไว้ท้ายสุด)
    return Object.values(map).sort((a, b) => {
      if (a.roundDate === "ไม่มีรอบ") return 1;
      if (b.roundDate === "ไม่มีรอบ") return -1;
      return a.roundDate.localeCompare(b.roundDate);
    });
  };

  const summary = buildSummary();
  const totalCarNew = summary.reduce((s, r) => s + r.carNew, 0);
  const totalCarAccepted = summary.reduce((s, r) => s + r.carAccepted, 0);
  const totalLandNew = summary.reduce((s, r) => s + r.landNew, 0);
  const totalLandAccepted = summary.reduce((s, r) => s + r.landAccepted, 0);
  const totalAll = summary.reduce((s, r) => s + r.total, 0);

  const columns = [
    {
      title: "รอบการส่ง",
      dataIndex: "roundLabel",
      key: "roundLabel",
    },
    {
      title: "รถ",
      children: [
        {
          title: "ยังไม่รับเคส",
          dataIndex: "carNew",
          key: "carNew",
          align: "center",
        },
        {
          title: "รับเคสแล้ว",
          dataIndex: "carAccepted",
          key: "carAccepted",
          align: "center",
        },
      ],
    },
    {
      title: "ที่ดิน",
      children: [
        {
          title: "ยังไม่รับเคส",
          dataIndex: "landNew",
          key: "landNew",
          align: "center",
        },
        {
          title: "รับเคสแล้ว",
          dataIndex: "landAccepted",
          key: "landAccepted",
          align: "center",
        },
      ],
    },
    {
      title: "ทั้งหมด",
      dataIndex: "total",
      key: "total",
      align: "center",
      render: (value) => <b>{value}</b>,
    },
  ];

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        icon={<ProfileOutlined />}
        onClick={showModal}
      >
        ตรวจเคสทั้งหมด
      </Button>
      <Modal
        open={open}
        onCancel={handleClose}
        footer={null}
        width={"80%"}
        maskClosable={false}
      >
        <Spin spinning={loading} tip="กำลังโหลด...">
          <Row>
            <Divider orientation="center">
              <b>สรุปจำนวนเคสตามรอบการส่ง</b>
            </Divider>
            <Col span={24} style={{ marginBottom: "20px" }}>
              <Table
                columns={columns}
                dataSource={summary}
                pagination={false}
                bordered
                size="middle"
                summary={() => (
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>
                      <b>รวมทั้งหมด</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1} align="center">
                      <b>{totalCarNew}</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2} align="center">
                      <b>{totalCarAccepted}</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3} align="center">
                      <b>{totalLandNew}</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={4} align="center">
                      <b>{totalLandAccepted}</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5} align="center">
                      <b>{totalAll}</b>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                )}
              />
            </Col>
            <Col span={24} style={{ textAlign: "right" }}>
              <Button onClick={handleClose}>ปิด</Button>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
}
export default ModalCheckAllCases;
